// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bulletin-container[data-v-5e414d9f] {\r\n  max-height: 600px;\r\n  overflow-y: auto;\n}\n.file-item[data-v-5e414d9f] {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  margin: 2px 0;\n}\n.file-item .el-link[data-v-5e414d9f] {\r\n  margin-right: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
